module.exports = __webpack_public_path__ + "static/img/story7.5109438.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bad/story7.gif
// module id = Ie3F
// module chunks = 0